<template>
  <v-card rounded width="94%" outlined class="rounded-xl">
    <v-carousel :height="widt + '%'" hide-delimiters v-model="model" show-arrows-on-hover>
      <v-carousel-item v-for="n in 15" :key="n">
        <v-container fluid>
          <v-col cols="12">
            <v-row class="mb-5">
              <v-card rounded depressed color="grey lighten-1" :height="widt" width="100%"></v-card>
            </v-row>
            <v-row class="mb-5">
              <v-card rounded depressed color="grey lighten-1" :height="widt" width="100%"></v-card>
            </v-row>
            <v-row>
              <v-card rounded depressed color="grey lighten-1" :height="widt" width="100%"></v-card>
            </v-row>
          </v-col>
        </v-container>
      </v-carousel-item>
    </v-carousel>
  </v-card>
</template>

<script>
export default {
  props: ["widt"],
  data: () => ({
    model: []
  })
};
</script>